import { render, staticRenderFns } from "./FormAdd.vue?vue&type=template&id=c3cf3e24&"
import script from "./FormAdd.vue?vue&type=script&lang=js&"
export * from "./FormAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports